"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const _4d_objects_1 = require("./4d-objects");
const _4d_helper_1 = require("./4d-helper");
const cesium_renderers_layer_1 = require("./renderers/cesium-renderers-layer");
const cesium_renderers_annot_1 = require("./renderers/cesium-renderers-annot");
const cesium_renderer_arcgis_1 = require("./renderers/cesium-renderer-arcgis");
const cesium_renderer_wms_1 = require("./renderers/cesium-renderer-wms");
const cesium_renderer_wfs_1 = require("./renderers/cesium-renderer-wfs");
const cesium_renderer_wtms_1 = require("./renderers/cesium-renderer-wtms");
var Cesium = window['Cesium'];
/**
 * <p>Helper class for <a href="https://cesiumjs.org/tutorials/">Cesium</a>. Contains methods to zoom to a location and add/remove a model to the map.</p>
 * <p>You can play with a(n) (<a href="https://stackblitz.com/edit/4dmapper-sdk">angular</a> or <a href="https://stackblitz.com/edit/react-demo-cesium">react</a>) demo on stackblitz.</p>
 */
class FourdCesiumHelper extends _4d_helper_1.MapHelper {
    constructor(fourdD, viewer, cesiumObject) {
        super();
        this.fourdD = fourdD;
        this.viewer = viewer;
        if (cesiumObject)
            Cesium = cesiumObject;
        else if (!Cesium)
            Cesium = window['Cesium'];
        //this.annotations = this.viewer.scene.primitives.add(new Cesium.LabelCollection());
        this.dziDatasource = new Cesium.CustomDataSource('dzi');
        this.annotationDataSource = new Cesium.CustomDataSource('annot');
        this.annotationLabels = this.viewer.scene.primitives.add(new Cesium.LabelCollection());
        //this.viewer.dataSources.add(this.dataSource)
        this.viewer.dataSources.add(this.dziDatasource);
        this.viewer.dataSources.add(this.annotationDataSource);
        this._originalTerrainProvider = viewer.scene.terrainProvider;
        this.registerRenderer(_4d_objects_1.Transform, 'terrain', new cesium_renderers_layer_1.TerrainRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'terrain-tiles', new cesium_renderers_layer_1.TerrainRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'kml', new cesium_renderers_layer_1.KMLRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'geo-json', new cesium_renderers_layer_1.KMLRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'tms', new cesium_renderers_layer_1.TMSRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'three-d-tiles', new cesium_renderers_layer_1.ThreeDTileRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'photo-dzi', new cesium_renderers_layer_1.PhotoRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'thumb', new cesium_renderers_layer_1.PhotoRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'laz', new cesium_renderers_layer_1.LASRenderer(this));
        this.registerRenderer(_4d_objects_1.Transform, 'arcgis-remote', new cesium_renderer_arcgis_1.ArcGisTransformRenderer(this.viewer));
        this.registerRenderer(_4d_objects_1.Transform, 'wms-remote', new cesium_renderer_wms_1.WMSTransformRenderer(this.viewer));
        this.registerRenderer(_4d_objects_1.Transform, 'wfs-remote', new cesium_renderer_wfs_1.WFSTransformRenderer(this.viewer));
        this.registerRenderer(_4d_objects_1.Transform, 'wmts-remote', new cesium_renderer_wtms_1.WMTSTransformRenderer(this.viewer));
        this.registerRenderer(_4d_objects_1.Annotation, '*', new cesium_renderers_annot_1.BlankAnnotationRenderer(this));
    }
    destroy() {
        super.destroy();
        this.viewer.dataSources.remove(this.annotationDataSource);
        this.viewer.dataSources.remove(this.dziDatasource);
    }
    /**
     * <p>Returns the respective CesiumPlottableReference object of a given [[PlottableModel]] object</p>
     * @param p [[PlottableModel]] object
     * @deprecated use #getMapObjectFor instead
     */
    getCesiumObjectFor(p) {
        var plot = this.getMapObjectFor(p);
        if (plot)
            return plot.object;
        else
            return null;
    }
    clearPlottables() {
        Object.keys(this.plotCache).forEach(k => this.removePlottable(this.plotCache[k].plottable));
    }
    sendCameraTo(t, duration = 500, args) {
        var proj = this.plotCache['_' + t.className() + '_' + t.id];
        if (proj && proj.boundingSphere)
            this.viewer.camera.flyToBoundingSphere(proj.boundingSphere);
        else if (proj && proj.position)
            this.viewer.camera.flyTo({
                destination: proj.position,
                duration: duration / 1000
            });
        else if (t instanceof _4d_objects_1.Annotation && t.camera) {
            this.viewer.camera.flyTo({
                destination: Cesium.Cartographic.toCartesian(Cesium.Cartographic.fromDegrees(t.camera.position.lng, t.camera.position.lat, t.camera.position.height)),
                duration: duration / 1000,
                orientation: {
                    heading: Cesium.Math.toRadians(t.camera.direction.heading),
                    pitch: Cesium.Math.toRadians(t.camera.direction.pitch),
                    roll: Cesium.Math.toRadians(t.camera.direction.roll)
                }
            });
        }
        else if (t instanceof _4d_objects_1.Transform && t.transformType && (t.transformType.uid == 'photo-dzi' || t.transformType.uid == 'thumb')) {
            var dest = null;
            if (args && args.vertical_invert) {
                var v = t.cartographic();
                v.height = args.vertical_invert - v.height;
                dest = Cesium.Cartographic.toCartesian(v);
            }
            else {
                dest = t.catresian();
            }
            var ori = t.heading != undefined && t.pitch != undefined && t.roll != undefined && (args && !args.ignoreOrientation) ?
                {
                    heading: Cesium.Math.toRadians(t.heading),
                    pitch: Cesium.Math.toRadians(t.pitch),
                    roll: Cesium.Math.toRadians(t.roll)
                } :
                { heading: Cesium.Math.toRadians(0),
                    pitch: Cesium.Math.toRadians(-90),
                    roll: Cesium.Math.toRadians(0)
                };
            this.viewer.camera.flyTo({
                destination: dest,
                orientation: ori
            });
        }
        else if (t instanceof _4d_objects_1.Annotation) {
            var c = t.cartographic();
            c.height = 1000;
            this.viewer.camera.flyTo({
                destination: Cesium.Cartographic.toCartesian(c),
                duration: duration / 1000
            });
        }
        else {
            this.viewer.camera.flyTo({
                destination: t.rectangle(),
                duration: duration / 1000
            });
        }
        var delaySubject = new rxjs_1.Subject();
        setTimeout(() => delaySubject.next(this.viewer.camera), duration + 100);
        return delaySubject.asObservable();
    }
    /**
     * <p>If the server supports it, get a token suffix that may be a remote storage server (eg S3 or Cloudfront URL)
     * Cesium can query resources directly rather than hit application server</p>
     * @param p [[PlottableModel]] Object
     * @param file Name of file
     * @param tier Applicable when Cloudfront is set up. Cesium allows request from one url at a time, so by providing a 'tier' which represents a different url, we can better conduct traffic. 0: default/Terrain Tiles, 1: Tile Map Service (tms), 2: 3D Tiles
     */
    getAuthenticatedUrl(p, file, tier = 0) {
        return fetch(p.file('DIRECT_TOKEN_URL') + '&tier=' + tier)
            .then(r => r.json())
            .then(r => {
            var url = p.file(file);
            if (r.status == 200 && r.payload.url && r.payload.prefix) {
                var array = r.payload.url.split('?');
                if (array.length == 2) {
                    url = array[0] + r.payload.prefix.replace(/\*/g, '') + file + '?' + array[1];
                }
            }
            return url;
        });
    }
    changeOpacity(t, opacity) {
        // opacity doesnt work for terrain and laz
        if (t.ds_type_uid !== 'laslaz' && t.ds_type_uid !== 'terrain-tiles') {
            var obj = this.getCesiumObjectFor(t);
            if (!obj)
                throw new Error("Plotted object not found for " + t.id);
            if (t.ds_type_uid === 'geo-json' || t.ds_type_uid === 'kml' || t.ds_type_uid === 'shape-zip' && obj._entityCollection) {
                obj._entityCollection.values.forEach(e => {
                    if (e.polyline && e.polyline.material && e.polyline.material.color) {
                        var color = new Cesium.Color(e.polyline.material.color._value.red, e.polyline.material.color._value.green, e.polyline.material.color._value.blue, opacity);
                        e.polyline.material.color = color;
                    }
                    else if (e.polygon && e.polygon.material && e.polygon.material.color) {
                        var color = new Cesium.Color(e.polygon.material.color._value.red, e.polygon.material.color._value.green, e.polygon.material.color._value.blue, opacity);
                        e.polygon.material.color = color;
                        if (opacity == 1) {
                            e.polygon.outline = true;
                        }
                        else {
                            e.polygon.outline = false;
                        }
                    }
                });
            }
            obj.alpha = opacity;
            obj.style = new Cesium.Cesium3DTileStyle({
                color: 'rgba(255, 255, 255,' + obj.alpha + ')'
            });
        }
    }
    resolveItem(movement) {
        var feature = this.viewer.scene.pick(movement.position);
        var def = Cesium.defined(feature);
        if (def && feature.id && feature.id.transform_id) {
            return this.plotCache['_Transform_' + feature.id.transform_id].plottable;
        }
        if (def && feature.id && feature.id.entityCollection && feature.id.entityCollection.transform_id) {
            return this.plotCache['_Transform_' + feature.id.entityCollection.transform_id].plottable;
        }
        if (def && feature.primitive && feature.primitive.transform_id) {
            return this.plotCache['_Transform_' + feature.primitive.transform_id].plottable;
        }
        if (def && !feature.content && feature.id && feature.id.fourd_ref) {
            return this.plotCache['_Annotation_' + feature.id.fourd_ref].plottable;
        }
        if (def && !feature.content && feature.primitive) {
            var f = null;
            Object.keys(this.plotCache).find(k => {
                if (this.plotCache[k].object == feature.primitive) {
                    f = this.plotCache[k].plottable;
                    return true;
                }
            });
            return f;
        }
    }
}
exports.FourdCesiumHelper = FourdCesiumHelper;
